import Vue from 'vue'
import {adminRoles, UserRoleEnum} from '../../enums/userRolesEnum'
import { BallPulseLoader } from 'vue-loaders';
import FacilityOwner from './facilityComponents/FacilityOwner.vue'
import FacilityStatus from './facilityComponents/FacilityStatus.vue'
import GeneralInformationCard from './cards/generalInformation/GeneralInformationCard'
import FacilityNotesCard from './cards/notes/FacilityNotesCard'
import FacilityDocumentsCard from './cards/documents/FacilityDocumentsCard'
import FacilitySpecialtyControl from './facilityComponents/FacilitySpecialtyControl.vue'
import FacilitySpecialtyRequirementsCard from './cards/facilitySpecialtyRequirements/FacilitySpecialtyRequirementsCard'
import FacilityContactsCard from './cards/facilityContacts/FacilityContactsCard'
import FacilitySpecialtyContactsCard from './cards/facilitySpecialtyContacts/FacilitySpecialtyContactsCard'
import FacilitySpecialtyRatesCard from './cards/facilitySpecialtyRates/FacilitySpecialtyRatesCard'
import FacilitySpecialtyCredentialedProvidersCard from './cards/facilitySpecialtyCredentialedProviders/FacilitySpecialtyCredentialedProvidersCard'
import FacilitySpecialtySummaryCard from './cards/FacilitySpecialtySummary/FacilitySpecialtySummaryCard'
import FacilitySpecialtyNotesCard from './cards/facilitySpecialtyNotes/FacilitySpecialtyNotesCard'
import FacilityFinancialCard from './cards/financial/FacilityFinancialCard';
import FaciltyChecklistCard from './cards/checklist/FacilityChecklistCard';
import FacilityCredentialDocument from "@/components/facility/cards/credentialdocument/FacilityCredentialDocument";
import FacilityContractCard from "@/components/facility/cards/facilityContracts/FacilityContractCard";
import EmailHistory from '@/components/communications/history/EmailHistory';

export default Vue.extend({
  name: 'Facilities',
  props: {
    'new-facility': { type: Boolean, default: false},
    facilityId: { type: [Number, String], required: false }
  },
  data () {
    return {
      cardExpanded: true,
      UserRoleEnum: UserRoleEnum,
      isAuthorized: false,
      loadingInitialData: false,
      facilityName: ''
    }
  },
  components: {
    BallPulseLoader,
    EmailHistory,
    FacilityOwner,
    FacilityStatus,
    FacilityNotesCard,
    FacilityDocumentsCard,
    FacilitySpecialtyControl,
    FacilitySpecialtyRequirementsCard,
    GeneralInformationCard,
    FacilityContactsCard,
    FacilitySpecialtyContactsCard,
    FacilitySpecialtyRatesCard,
    FacilitySpecialtyCredentialedProvidersCard,
    FacilitySpecialtySummaryCard,
    FacilitySpecialtyNotesCard,
    FacilityFinancialCard,
    FaciltyChecklistCard,
    FacilityCredentialDocument,
    FacilityContractCard
  },
  computed: {
    isFacilityUser(): boolean {
      return this.$store.state.user.isFacility;
    },
    isAuthorizedforAccounting (): boolean {
      return this.$store.getters['user/hasRole']([
        UserRoleEnum.MANAGER,
        UserRoleEnum.ACCOUNTANT
      ]);
    }
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole']([...adminRoles, UserRoleEnum.FACILITY_CONTACT
    ]);
  },
  methods: {
    facilityLoaded (facility: any) {
      if (!this.isFacilityUser || !facility) {
        return;
      }
      this.facilityName = facility.name;
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/facility/Facility.ts